var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"external-bidder-chip h9-text d-flex align-center justify-center main__green rounded-xl px-2 py-1",attrs:{"data-qa":"external-bidder"}},[_vm._v(" "+_vm._s(_vm.$t('Tenders.External'))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }